module.exports = __webpack_public_path__ + "static/media/notion.19b0f813.svg";